import React from "react";
import styles from "./index.module.css";
import Loader from "shared/Loader";
import { useAmwayDetails } from "./useAmwayDetails";

export default function AmwayDetails({ iboNumber }) {
  const { amwayData, iboInfo, amwayDetailsLoading } =
    useAmwayDetails(iboNumber);

  if (amwayDetailsLoading) {
    return (
      <div className={styles.outer}>
        <div className={styles.container}>
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.outer}>
      <div className={styles.container}>
        <div className={styles.topRow}>
          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.amwayLabel}`}>
              Amway Status
            </div>
            <div className={`${styles.infoValue} ${styles.amwayValue}`}>
              {amwayData?.status ?? "—"}
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.paymentLabel}`}>
              Payment Eligible
            </div>
            <div className={`${styles.infoValue} ${styles.paymentValue}`}>
              {amwayData?.payment_eligible ?? "—"}
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.consentLabel}`}>
              Consent Provided
            </div>
            <div className={`${styles.infoValue} ${styles.consentValue}`}>
              {amwayData?.consent_provided ?? "—"}
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.pinLabel}`}>
              Current Pin Level
            </div>
            <div className={`${styles.infoValue} ${styles.pinValue}`}>
              {iboInfo?.lineOfSponsorship?.pinLevel ?? "—"}
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.pinLabel}`}>
              Highest Pin Level
            </div>
            <div className={`${styles.infoValue} ${styles.pinValue}`}>
              {amwayData?.highestAward ?? "—"}
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoLabel} ${styles.pinLabel}`}>
              Highest Award Date
            </div>
            <div className={`${styles.infoValue} ${styles.pinValue}`}>
              {amwayData?.highestAwardDate ?? "—"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
